// extracted by mini-css-extract-plugin
module.exports = {"inner":"index-module--inner--2vv_m"};